module.exports = __webpack_public_path__ + "img/subject-image.c4180169.png";